import { TOUR_LINK_IDS } from 'utils/consts';
import { setActionType, toggleSlimMode } from 'actions/reports';
import { reportDataSelectors } from 'selectors/reports';
import { getUserData } from 'selectors/user';
import { reportTypes, unenrichedButton } from 'utils/reports';
import { getFieldPresetButtons } from './fieldPresets';

import {
    admonAlignmentToggle,
    getBaseConfig,
    getCompare,
    getDatePicker,
    getEmptyStateConfig,
    getExpandedFiltersButton,
    getRegularMode,
    getSecondDatePicker,
    getVsLabel,
    shelfAssistMetrics,
    shelfOrganicInsightsDimensions,
    shelfAttributionInsightsDimensions,
    shelfPromotedContentDetails,
    shelfCohortMetrics,
    shelfConversionEvents,
    shelfCreativeMeasurement,
    shelfCrossDeviceDemoCohortType,
    shelfCustomDimensions,
    shelfCustomEvents,
    shelfDimensions,
    shelfDiscrepancies,
    shelfEnrichmentDimensions,
    shelfFileCombinerDimensions,
    shelfGovernanceDimensions,
    shelfGranularityLevels,
    shelfMetadataDimensions,
    shelfMetrics,
    shelfNetworkData,
    shelfReportingAppMetrics,
    shelfReportingWebMetrics,
    shelfSearchCampaignDimensions,
    shelfSocialEngagementMetrics,
    shelfSourceAttributionType,
    shelfTimeBreakdowns,
    shelfTrackerData,
    shelfUTMParamsFields,
    shelfVideoMetrics,
    shelfXorgCohortMetrics,
    shelfXorgMetrics,
    unenrichedToggle,
} from './baseReportConfig';
import { shelfPeriods } from './shelfPeriods';

// widgets
const Toggle = 'Toggle';

const type = reportTypes.pivot;
const path = '/react/pivot';

const basicConfig = getBaseConfig(type, 'STATIC.PAGE_HEADERS.PIVOT', 'pivot');
const compareConfig = getCompare(type);

export default {
    ...basicConfig,
    path,
    chart: {
        enabled: false,
        show: false,
    },
    events: {
        load: ['Pivot: Page Loaded'],
        urlQuery: ['Pivot: Query Loaded From URL'],
    },
    header: {
        text: 'STATIC.PAGE_HEADERS.PIVOT',
        subText: {
            faqLink: 'https://support.singular.net/hc/en-us/articles/360031266632',
            tourId: TOUR_LINK_IDS.pivot,
        },
        emptyStateHeaderData: getEmptyStateConfig('PIVOT'),
        leftComponents: [
            getDatePicker(type),
            getVsLabel(type),
            getSecondDatePicker(type),
            {
                ...compareConfig,
                selector: state => {
                    const baseResult = compareConfig.selector(state);
                    return {
                        ...baseResult,
                        containerStyle: {
                            ...baseResult.containerStyle,
                            marginRight: '10px',
                        },
                    };
                },
            },
            getRegularMode(type),
            getExpandedFiltersButton(type),
            {
                id: 'toggle_slim_mode',
                componentClass: Toggle,
                props: {
                    label: 'STATIC.BUTTONS.ADVANCED_VIEW',
                },
                selector: state => {
                    const selected = reportDataSelectors[type](state);
                    const userData = getUserData(state);

                    return {
                        checked: userData.show_report_toggle && !selected.isSlimMode,
                        style: {
                            display:
                                userData.show_report_toggle && selected.showFieldsSelection ? 'inline-block' : 'none',
                            marginLeft: '10px',
                            width: '165px',
                        },
                    };
                },
                actions: [
                    {
                        actionName: 'onToggle',
                        action: ({ target }) => {
                            return setActionType(toggleSlimMode(!target.checked), type);
                        },
                    },
                ],
            },
        ],
        rightComponents: [
            ...basicConfig.header.rightComponents,
            unenrichedButton(type),
            ...getFieldPresetButtons(type),
        ],
    },
    shelf: [
        shelfTimeBreakdowns,
        shelfDimensions,
        shelfMetadataDimensions,
        shelfOrganicInsightsDimensions,
        shelfAttributionInsightsDimensions,
        shelfPromotedContentDetails,
        shelfUTMParamsFields,
        shelfSearchCampaignDimensions,
        shelfCreativeMeasurement,
        shelfFileCombinerDimensions,
        shelfGranularityLevels,
        shelfEnrichmentDimensions,
        shelfGovernanceDimensions,
        shelfCustomDimensions,
        shelfMetrics,
        shelfXorgMetrics,
        shelfAssistMetrics,
        shelfSocialEngagementMetrics,
        shelfVideoMetrics,
        shelfReportingWebMetrics,
        shelfReportingAppMetrics,
        shelfConversionEvents,
        shelfCohortMetrics,
        shelfXorgCohortMetrics,
        shelfCustomEvents,
        shelfPeriods,
        shelfTrackerData,
        shelfNetworkData,
        shelfDiscrepancies,
        shelfSourceAttributionType,
        shelfCrossDeviceDemoCohortType,
        unenrichedToggle,
        admonAlignmentToggle,
    ],
};
